import React from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { slide as Menu } from "react-burger-menu"
import PropTypes from "prop-types"
import { document } from "browser-monads"

const MenuStyle = styled(Menu)``

const MenuWrapper = styled.div`
  position: fixed;
  z-index: 705;
  top: 0;
  width: 100%;

  @media only screen and (${props => props.theme.screen.mobile.max}) {
    .bm-menu-wrap {
      width: 100% !important;
    }
  }
`

const BackButton = styled.div`
  color: ${props => props.theme.silverShade};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: max-content;
  }
`

const MenuHolder = styled.div`
  max-height: calc(100vh - 144px);

  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-right: 12px;
  /* overflow-y: scroll; */
`

const MenuSlider = ({ children, isOpen, setIsOpen }) => {
  const MobileMenuStyles = {
    bmBurgerButton: {
      display: "none",
    },
    bmCrossButton: {
      display: "none",
    },
    // Also see bm-menu-wrap styling above
    bmMenuWrap: {
      paddingTop: "0px",
      position: "fixed",
      width: "425px",
      height: "100%",
    },
    bmMenu: {
      background: "#fff",
      padding: "42px 12px 8px 24px",
      width: "100%",
      height: "100%",
      overflow: "hidden",
    },
    bmMorphShape: {
      fill: "#373a47",
    },
    bmItemList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: "24px",
    },
    bmItem: {
      display: "flex",
    },
    bmOverlay: {
      background: "rgba(0, 0, 0, 0.3)",
    },
  }

  const sliderContent = (
    <MenuWrapper>
      <MenuStyle
        right
        styles={MobileMenuStyles}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <BackButton onClick={() => setIsOpen(false)}>
          <div>
            <LeftArrow />
          </div>
          Back
        </BackButton>
        <MenuHolder>{children}</MenuHolder>
      </MenuStyle>
    </MenuWrapper>
  )

  // Use ReactDOM.createPortal to render into the ___gatsby element
  const portalTarget =
    typeof window !== "undefined" && document.getElementById("___gatsby")
  return portalTarget
    ? ReactDOM.createPortal(sliderContent, portalTarget)
    : null
}

export default MenuSlider

MenuSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
}

const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12.6667 8.00002L3.33334 8.00002M3.33334 8.00002L8 12.6667M3.33334 8.00002L8.00001 3.33335"
        stroke="#667085"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
